import React, { useCallback, useEffect } from 'react';
import DownloadAgenciesBalanceReportButtonProperties from "./DownloadAgenciesBalanceReportButtonProperties";
import RoundedButton from "../../../ui_components/RoundedButton/RoundedButton";
import {Observer} from "mobx-react-lite";
import {useStyles} from "./DownloadAgenciesBalanceReportButton.style";
import Button from "../../../ui_components/Button/Button";
import ButtonType from "../../../ui_components/Button/ButtonType";
import ButtonSize from "../../../ui_components/Button/ButtonSize";
import SidePanel from "../../../ui_components/SidePanel/SidePanel";
import { Config } from '../../../util/Config';
import DocumentViewer from '../../../ui_components/DocumentViewer/DocumentViewer';
import PrintIcon from '@mui/icons-material/Print';

const DownloadAgenciesBalanceReportButton: React.FC<DownloadAgenciesBalanceReportButtonProperties> = ({
                                                                      onClick = () => {
                                                                      },
                                                                      onSave = () => {
                                                                      },
                                                                      children,
                                                                      showIcon = true,
                                                                      showText = true,
                                                                      disabled,
                                                                      className = '',
                                                                      rounded = false,
                                                                      showButton = true,
                                                                      size = ButtonSize.DEFAULT,
                                                                      type = ButtonType.DEFAULT,
                                                                  }) => {
    
    const getInvoiceUrl = useCallback(() => {
        return Config.get("GET_AGENCIES_BALANCE_REPORT_URL");
    }, []);

    const classes = useStyles(showText);
    const [isModalOpen, setIsModalOpen] = React.useState(false);
    const [invoiceUrl, setInvoiceUrl] = React.useState(getInvoiceUrl());

    useEffect(() => {
        setInvoiceUrl(getInvoiceUrl());
    }, [getInvoiceUrl]);

    const handleOnclick = async () => {
        setIsModalOpen(true);
        onClick();
    }

    const onCloseModal = () => {
        setIsModalOpen(false);
        if (onSave) {
            onSave();
        }
    }

    const text = 'Saldo de agencias';
    const Icon = PrintIcon;
    const Btn = () => {
        if (rounded) {
            return <RoundedButton
                onClick={handleOnclick}
                className={className}
                disabled={disabled}
                tooltip={!showText ? text : ""}
                text={showText ? text : ""}
                type={type}
                icon={showIcon ? <Icon/> : <></>}
            />
        }
        return <Button
            text={showText ? text : ""}
            className={className}
            tooltip={!showText ? text : ""}
            disabled={disabled}
            size={size}
            onClick={handleOnclick}
            type={type}
            startIcon={showIcon ? <Icon/> : <></>}
        />
    }

    return <Observer>
    {() => (
        <>
            <SidePanel title={'Imprimir saldo de agencias'}
                       onClose={onCloseModal} open={isModalOpen} className={classes.modal_container}>
                <div className={classes.view_invoice_container}>
                    {isModalOpen && <DocumentViewer url={invoiceUrl}/>}
                </div>
            </SidePanel>
            {showButton && <Btn/>}
            {!showButton && <div onClick={handleOnclick}>{children}</div>}
        </>
    )}
</Observer>
}

export default DownloadAgenciesBalanceReportButton;
